import type { TFunction } from "i18next"

export type SuffixOption = { value: string; label: string }

/** Title/suffix dropdown; English honorifics use i18n, Arabic honorifics stay as stored values. */
export function buildSuffixOptions(t: TFunction): SuffixOption[] {
  return [
    { value: "Mr", label: t("eventDashboardV2.suffix.Mr") },
    { value: "Mrs", label: t("eventDashboardV2.suffix.Mrs") },
    { value: "Dr", label: t("eventDashboardV2.suffix.Dr") },
    { value: "المكرمة", label: "المكرمة" },
    { value: "المكرم", label: "المكرم" },
    { value: "الاستاذ", label: "الاستاذ" },
  ]
}
